import { render, staticRenderFns } from "./PortalRequestNewStep.vue?vue&type=template&id=047abc3a"
import script from "./PortalRequestNewStep.vue?vue&type=script&lang=js"
export * from "./PortalRequestNewStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports